"use strict";

exports.__esModule = true;
exports.default = exports.getLocalizedStringSchema = void 0;

const getLocalizedStringSchema = props => {
  const registry = props.registry;
  const languages = registry.formContext.languages;
  let fieldSchema = {
    type: "object",
    properties: {}
  };
  languages.map(locale => {
    const localeId = "locale:" + locale;
    const title = props.name || props.title;
    fieldSchema.properties[localeId] = {
      title: title + ":" + locale,
      type: "string"
    };
  });
  return fieldSchema;
};

exports.getLocalizedStringSchema = getLocalizedStringSchema;
var _default = getLocalizedStringSchema;
exports.default = _default;